import { create, v } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/framework/core/middleware/theme';

// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { WNodeFactory, WidgetProperties, DNode } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { I18nProperties, DefaultChildrenWNodeFactory } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';

import { publish } from 'pub-sub';
import { createNlsMiddleware, lccstate, userstate } from 'lcc-state';
import { Keys } from '@holmescorp/common';

import css from '../css/footer.m.css';

function getCopyrightKey(): string {
	const copyrightKey =
		getComputedStyle(document.documentElement).getPropertyValue('--dynls-copyright') || 'copyright';
	return copyrightKey.trim();
}

const nls = createNlsMiddleware('settings');
const factory = create({ theme, lccstate, userstate, nls });

export const Footer = factory(({ middleware: { theme, lccstate, userstate, nls } }) => {
	const quizPattern = (() => {
		const { get, path } = userstate;
		return get(path('quizPattern'));
	})();

	const { get, path } = lccstate;
	// const online = get(path('online'));
	// const quizRunning = get(path('quizRunning')) > 0;
	const quizpatterns = get(path('quizpatterns'));
	const options: string[] = quizpatterns ? Object.keys(quizpatterns).sort() : [];
	const themeCss = theme.classes(css);

	const { isPlaceholder, messages } = nls();
	if (isPlaceholder) {
		return v('footer', { role: 'contentinfo', key: 'footer', classes: [theme.variant(), themeCss.root] });
	}

	const copyright = messages[getCopyrightKey()];
	const disclaimer = messages['disclaimer'];
	const privacy_policy_text = messages['privacy_policy_text'];
	const privacy_policy_url = messages['privacy_policy_url'];
	const privacy_policy = messages['privacy_policy'];

	const keyDownHandler = (event: KeyboardEvent) => {
		event && event.stopPropagation();
		switch (event.key) {
			case Keys.Enter:
			case Keys.Space:
			case Keys.Spacebar:
				event.preventDefault();
				publish('settings/open');
		}
	};

	const clickHandler = (event: MouseEvent) => {
		event && event.stopPropagation();
		publish('settings/open');
	};

	return v('footer', { role: 'contentinfo', key: 'footer', classes: [theme.variant(), themeCss.root] }, [
		disclaimer ? v('div', { key: 'disclaimer', classes: [themeCss.disclaimer] }, [disclaimer]) : null,
		v('div', { key: 'copyright', classes: [themeCss.copyright] }, [copyright]),
		quizpatterns && options.length > 1 && quizPattern
			? v(
					'div',
					{
						key: 'selector',
						xqa: 'selected quizpattern',
						role: 'button',
						tabIndex: 0,
						classes: [themeCss.selector],
						onclick: (event) => clickHandler(event),
						onkeydown: (event) => keyDownHandler(event)
					},
					[quizpatterns![quizPattern]]
			  )
			: v('div', { key: 'selector' }),
		v('div', { key: 'privacyprolicy', classes: [themeCss.privacypolicy] }, [
			disclaimer
				? v('div', { innerHTML: privacy_policy }) // two links - [ Accessibility | Privacy Policy ] - from dynls
				: v('a', { href: privacy_policy_url, target: '_blank' }, [privacy_policy_text])
		])
	]);
});

export default Footer;
